<template>
  <div>
    <b-card no-body class="p-1">
      <b-overlay :show="showLoading" rounded="sm">
        <b-button
          v-if="
            USER().rol === ROLES.SUPER ||
              USER().rol === ROLES.ADMIN ||
              USER().rol === ROLES.SANCIONES
          "
          v-b-tooltip.hover.v-primary
          title="Crear sancion especial"
          variant="flat-primary"
          class="btn-icon mb-1"
          size="sm"
          @click="showNewSancionOnly"
        >
          <feather-icon size="14" icon="UserXIcon" />
        </b-button>
        <b-table
          ref="refInvoiceListTable"
          :fields="tableColumns"
          :items="listSancionados"
          primary-key="id"
          show-empty
          responsive
          small
          empty-text="No se encontraron datos"
          class="position-relative"
          style="max-height:60vh"
          :sticky-header="true"
          :no-border-collapse="true"
        >
          <!-- Column: Player -->
          <template #cell(jugador)="data">
            <b-media vertical-align="center">
              <template #aside>
                <div style="display:grid">
                  <b-avatar
                    size="32"
                    :src="data.item.foto_jug"
                    :text="avatarText(data.item.nombres)"
                  />
                </div>
              </template>
              <span class="font-weight-bold d-block text-nowrap">
                {{ data.item.apellidos }} {{ data.item.nombres }}
              </span>
              <small class="text-muted">{{ data.item.ci_pasaporte }}</small>
            </b-media>
          </template>

          <template #cell(finaliza_en)="data">
            <template>
              <b-badge
                pill
                :variant="data.item.cumplida ? 'success' : 'warning'"
              >
                {{ data.item.finaliza_en }}
              </b-badge>
            </template>
          </template>

          <!-- Column: Actions -->
          <template #cell(opc)="data">
            <div class="text-nowrap">
              <feather-icon
                icon="EditIcon"
                class="cursor-pointer"
                size="16"
                @click="getDetalle(data.item)"
              />
              <feather-icon
                v-if="
                  USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.SANCIONES
                "
                icon="Trash2Icon"
                size="16"
                class="mx-1 cursor-pointer"
                @click="showModalConfirmacion(data.item)"
              />
            </div>
          </template>
        </b-table>
      </b-overlay>
      <b-modal
        id="modal-multi-3"
        size="sm"
        title="Confirmación"
        ok-only
        ok-title="Accept"
        v-model="showEliminarEspecial"
      >
        <b-card-text class="my-1">
          ¿ Deseas Eliminar la sanción ?
        </b-card-text>
        <template #modal-footer>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="showEliminarEspecial = false"
          >
            Cancelar
          </b-button>
          <b-button
            v-if="!showLoadingEliminar"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="deleteEspecial"
          >
            Aceptar
          </b-button>
          <div v-if="showLoadingEliminar" class="text-center mt-1">
            <b-spinner variant="primary" label="Text Centered" />
          </div>
        </template>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BOverlay,
  BTable,
  BMedia,
  BAvatar,
  BBadge,
  BButton,
  VBTooltip,
  BModal,
  BCardText,
  BSpinner,
  //   BIconLayers,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  // INSERT_DATA_PLAYER,
  // INSERT_DATA_HISTORY_PLAYER,
  // UPDATE_DATA_PLAYER,
  // ESTADO_JUGADOR,
} from '../../utils/variables'
// import modalLog from './LogDetalle.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BMedia,
    BAvatar,
    BBadge,
    BButton,
    BModal,
    BCardText,
    BSpinner,
    // modalLog,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    listSancionados: Array,
    showLoading: Boolean,
  },
  setup(props, { emit }) {
    // const showLoading = ref(false)
    const tableColumns = [
      { key: 'id_sancion', label: 'id', sortable: true },
      { key: 'jugador', sortable: true },
      { key: 'fecha_sancion', sortable: true },
      { key: 'fecha_fin_especial', sortable: true },
      { key: 'finaliza_en', sortable: true },
      // { key: 'estado_jug', sortable: true },
      { key: 'opc' },
    ]
    const { postApi } = apiCall()
    // const listSancionados = ref([])
    const dataLog = ref(null)
    const showEliminarEspecial = ref(false)
    const showLoadingEliminar = ref(false)
    const sancionElegida = ref(null)
    function getDetalle(item) {
      // console.log(props)
      emit('getDetalleEspecial', item)
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', true)
    }
    function showNewSancionOnly() {
      emit('onlyEspecial')
    }
    // const { getApi } = apiCall()
    // async function getEspeciales(idTorneo) {
    //   listSancionados.value = []
    //   showLoading.value = true
    //   const path = `ApiSanciones/getSancionesEspeciales/${idTorneo}`
    //   const data = await getApi(URL, path)
    //   listSancionados.value = data.data
    //   showLoading.value = false
    // }
    // onMounted(() => {
    //   getEspeciales(
    //     // eslint-disable-next-line
    //     store.getters['someVariables/getTorneoSeleccionado'].id_torneo
    //   )
    //   // console.log(refP.value)
    // })
    function showModalLog(item) {
      dataLog.value = item
      store.commit('someVariables/UPDATE_SHOW_MODAL_LOG', true)
    }
    function showModalConfirmacion(item) {
      showEliminarEspecial.value = true
      sancionElegida.value = item
      // console.log(sancionElegida.value)
    }
    async function deleteEspecial() {
      showLoadingEliminar.value = true
      const path = 'ApiSanciones/deleteSancionEspecial'
      const data = {
        idSancion: sancionElegida.value.id_sancion,
        idUsuario: USER().id_usuario,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        dataMovimiento: `Elimina la sanción especial del jugador/a ${sancionElegida.value.apellidos} ${sancionElegida.value.nombres} sancionado
        desde ${sancionElegida.value.inicio_auxiliar} hasta ${sancionElegida.value.fin_auxiliar}`,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'SANCION ELIMINADA exitosamente',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'top-bottom',
            // eslint-disable-next-line
          }
        )
        emit('recargaEspeciales')
        showEliminarEspecial.value = false
        // insertMultasTarjetasAutomatico()
      }
      showLoadingEliminar.value = false
    }

    return {
      // showLoading,
      tableColumns,
      // listSancionados,
      showModalLog,
      // modalLog,
      dataLog,
      avatarText,
      getDetalle,
      showNewSancionOnly,
      ROLES,
      USER,
      showEliminarEspecial,
      showLoadingEliminar,
      showModalConfirmacion,
      deleteEspecial,
    }
  },
}
</script>
